
const selectorsCommonAR = {
  "selectors_clear": "الكل",
}

const selectorsPlaceholdersAR = {
  "selectors_grower_placeholder": "اختر مزارعًا",
  "selectors_car_placeholder": "اختر سيارة",
  "selectors_warehouse_placeholder": "اختر مستودعًا",
  "selectors_teudaType_placeholder": "اختر نوع المستند",
  "selectors_product_placeholder": "اختر منتجًا",
  "selectors_size_placeholder": "اختر حجمًا",
  "selectors_package_placeholder": "اختر عبوة",
  "selectors_palletType_placeholder": "اختر بالت",
  "selectors_report_placeholder": "اختر تقريرًا",
}

const selectorsEmptyAR = {
  "selectors_grower_empty": "لا يوجد مزارعون مطابقون",
  "selectors_car_empty": "لا توجد سيارات مطابقة",
  "selectors_warehouse_empty": "لا توجد مستودعات مطابقة",
  "selectors_teudaType_empty": "لا توجد أنواع مطابقة",
  "selectors_product_empty": "لا توجد منتجات مطابقة",
  "selectors_size_empty": "لا توجد أحجام مطابقة",
  "selectors_package_empty": "لا توجد عبوات مطابقة",
  "selectors_palletType_empty": "لا توجد بالتات مطابقة",
  "selectors_report_empty": "لا توجد تقارير مطابقة",
  "selectors_location_empty": "لا توجد مواقع مطابقة",
}

export const selectorsTranslationAR = {
  selectors: {
    ...selectorsCommonAR,
    ...selectorsPlaceholdersAR,
    ...selectorsEmptyAR,
  }
}
